import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { t } from "i18next";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

type Props = { title: string; icon: string; hidePeriodSelector?: boolean };

const GenericToolbar = (props: Props) => {
  const useIconStyles = makeThemedStyles("GenericToolbarIcon", (theme) => ({
    root: {
      marginLeft: 0,
      marginRight: "15px",
      marginTop: 0,
      width: "40px",
      height: "40px",
      backgroundImage: `url(${getFileApiURL(props.icon)})`,
      backgroundSize: "40px 40px",
    },
  }));

  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {t(props.title)}
        </ToolbarTitle>
        {props.hidePeriodSelector ? null : (
          <Right>
            <PeriodSelector />
          </Right>
        )}
      </SplitView>
    </ToolbarContainer>
  );
};

export default GenericToolbar;
